import { computePosition, flip, shift } from "@floating-ui/dom";
import { posToDOMRect } from "@tiptap/react";

export const updatePosition = (editor: any, element: HTMLElement) => {
    const virtualElement = {
        getBoundingClientRect: () => posToDOMRect(editor.view, editor.state.selection.from, editor.state.selection.to),
    };
    element.style.width = "max-content";
    requestAnimationFrame(() => {
        if (!element.isConnected) return;
        void computePosition(virtualElement, element, {
            placement: "bottom-start",
            strategy: "absolute",
            middleware: [flip(), shift()],
        }).then(({ x, y, strategy }) => {
            element.style.position = strategy;
            element.style.left = `${x}px`;
            element.style.top = `${y}px`;
        });
    });
};
